<template>
	<div>
		<div v-show="loading">
			Loading...&nbsp;<font-awesome-icon :icon="circleNotch" spin />
		</div>
		<div v-show="error">{{ error }}</div>
		<basic-spacetimator
			:items="items"
			:spaces="spaces"
			:recomendations="recomendations"
			:units="units"
			:text-dark="textDark"
			:text-darker="textDarker"
			:bg-light="bgLight"
			:bg-lighter="bgLighter"
			:bg-lightest="bgLightest"
			:border-lighter="borderLighter"
			:primary-button-bg="primaryButtonBg"
			:primary-button-bg-hover="primaryButtonBgHover"
			:primary-button-text="primaryButtonText"
			:secondary-button-bg="secondaryButtonBg"
			:secondary-button-bg-hover="secondaryButtonBgHover"
			:secondary-button-text="secondaryButtonText"
			:tertiary-button-bg="tertiaryButtonBg"
			:tertiary-button-bg-hover="tertiaryButtonBgHover"
			:tertiary-button-text="tertiaryButtonText"
			v-show="!loading && !error">
			<slot></slot>
		</basic-spacetimator>
	</div>
</template>

<script>
	import basicSpacetimator from './basic-spacetimator'
	import axios from 'axios'
	import { library } from '@fortawesome/fontawesome-svg-core'
	import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

	library.add(faCircleNotch)

	export default {
		props: {
			recomendations: {
				type: Number,
				required: false
			},
			units: {
				type: String,
				default: 'metric',
				validator: function (value) {
					return ['metric', 'imperial'].indexOf(value) !== -1
				}
			},
			textDark: {
				type: String,
				required: false
			},
			textDarker: {
				type: String,
				required: false
			},
			bgLight: {
				type: String,
				required: false
			},
			bgLighter: {
				type: String,
				required: false
			},
			bgLightest: {
				type: String,
				required: false
			},
			borderLighter: {
				type: String,
				required: false
			},
			primaryButtonBg: {
				type: String,
				required: false
			},
			primaryButtonBgHover: {
				type: String,
				required: false
			},
			primaryButtonText: {
				type: String,
				required: false
			},
			secondaryButtonBg: {
				type: String,
				required: false
			},
			secondaryButtonBgHover: {
				type: String,
				required: false
			},
			secondaryButtonText: {
				type: String,
				required: false
			},
			tertiaryButtonBg: {
				type: String,
				required: false
			},
			tertiaryButtonBgHover: {
				type: String,
				required: false
			},
			tertiaryButtonText: {
				type: String,
				required: false
			},
		},
		data() {
			return {
				loading: true,
				error: "",
				items: [],
				spaces: [],
			}
		},
		computed: {
			circleNotch() {
				return faCircleNotch
			}
		},
		mounted() {
			axios.get(this.getApiUrl()).then(response => {
				var acf = response.data.acf
				this.items = JSON.parse(new DOMParser().parseFromString(acf.items, "text/html").documentElement.textContent)
				this.spaces = JSON.parse(new DOMParser().parseFromString(acf.spaces, "text/html").documentElement.textContent)
				this.loading = false
			}).catch(error => {
				this.loading = false
				console.log(error)
				this.error = error.response ? error.response.data.message : 'Something went wrong'
			})
		},
		methods: {
			getPageId() {
				return bbb_spacetimator_vars.page_id
			},
			getApiUrl() {
				return '/wp-json/wp/v2/pages/' + this.getPageId()
			},
		},
		components: {
			basicSpacetimator,
			FontAwesomeIcon
		}
	}
</script>